/**
 * eBoutique API
 * eBoutique API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TransactionBundle } from './transactionBundle';
import { ValidationContextImpl } from './validationContextImpl';

export class TransactionWrapper {
  dataRetrievalFailureException?: string;
  parameters?: Array<any> = [];
  queryServiceName?: string;
  validationContext?: ValidationContextImpl;
  transactionBundle?: TransactionBundle;
  loanNumber?: string;
  effDate?: string;
  appCode: string;
  object?: object;
}
